<template>
  <div id="userInfo" @click="clickAreaFn($event)">
    <template v-if="canDoSm" v-loading="loadingAll">
      <div class="info-box" v-if="isPerson">
        <div class="form_item">
          <div class="col">
            <label for="name">
              <i>*</i>
              真实姓名：
            </label>
            <input
              :disabled="!isLogin"
              class="input"
              id="name"
              type="text"
              name="name"
              v-model="form.name"
              placeholder="请输入真实姓名"
            />
          </div>
          <span class="error-txt" v-if="errors.fields && errors.fields.name">{{
            errors.fields.name[0].message
          }}</span>
        </div>
        <div class="form_item">
          <div class="col">
            <label for="province">
              <i>*</i>
              学校省份：
            </label>
            <div class="input" @click="showPopup('province')">
              <template>
                <p class="placeholder" v-if="!form.province">
                  请选择学校所在省份
                </p>
                <p class="select-div" v-else>
                  {{ provinceValue.name }}
                </p>
              </template>

              <van-popup
                v-model="showProvincePop"
                position="bottom"
                :style="{ height: '45%' }"
              >
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="provinceArr"
                  @confirm="confirmProvincePop"
                />
              </van-popup>
            </div>
          </div>
          <span
            class="error-txt"
            v-if="errors.fields && errors.fields.province"
            >{{ errors.fields.province[0].message }}</span
          >
        </div>
        <div class="form_item">
          <div class="col">
            <label for="city">
              <i>*</i>
              学校城市：
            </label>
            <div class="input" @click="showPopup('city')">
              <template>
                <p class="placeholder" v-if="!form.city">
                  请选择学校所在城市
                </p>
                <p class="select-div" v-else>
                  {{ cityValue.name }}
                </p>
              </template>

              <van-popup
                v-model="showCityPop"
                position="bottom"
                :style="{ height: '45%' }"
              >
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="cityArr"
                  @confirm="confirmCityPop"
                />
              </van-popup>
            </div>
          </div>
          <span class="error-txt" v-if="errors.fields && errors.fields.city">{{
            errors.fields.city[0].message
          }}</span>
        </div>
        <div class="form_item">
          <div class="col">
            <label for="school">
              <i>*</i>
              学校名称：
            </label>
            <div class="input" @click="showPopup('school')">
              <template>
                <p class="placeholder" v-if="!form.school">
                  请选择所在学校
                </p>
                <p class="select-div" v-else>
                  {{ schoolValue.name }}
                </p>
              </template>

              <van-popup
                v-model="showSchoolPop"
                position="top"
                :style="{ height: '45%' }"
              >
                <div class="search-bar">
                  <input
                    class="search-input"
                    id="school"
                    type="text"
                    name="school"
                    v-model="schoolKeyWord"
                    @input="searchSchool"
                    placeholder="请输入搜索关键词"
                  />
                </div>
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="schoolArr"
                  @confirm="confirmSchoolPop"
                />
              </van-popup>
            </div>
          </div>
          <span
            class="error-txt"
            v-if="errors.fields && errors.fields.school"
            >{{ errors.fields.school[0].message }}</span
          >
        </div>
        <div class="form_item">
          <div class="col">
            <label for="profession">
              <i>*</i>
              院系：
            </label>
            <input
              :disabled="!isLogin"
              class="input"
              id="profession"
              type="text"
              name="profession"
              v-model="form.profession"
              placeholder="请输入院系"
            />
          </div>
          <span
            class="error-txt"
            v-if="errors.fields && errors.fields.profession"
            >{{ errors.fields.profession[0].message }}</span
          >
        </div>
        <div class="form_item">
          <div class="col">
            <label for="phone">
              <i>*</i>
              手机号码：
            </label>
            <input
              :disabled="!isLogin"
              class="input"
              id="phone"
              type="text"
              name="phone"
              v-model="form.phone"
              placeholder="请输入手机号码"
            />
          </div>
          <span class="error-txt" v-if="errors.fields && errors.fields.phone">{{
            errors.fields.phone[0].message
          }}</span>
        </div>
        <div class="form_item">
          <div class="col">
            <label for="qq">
              <i>*</i>
              QQ号码：
            </label>
            <input
              :disabled="!isLogin"
              class="input"
              id="qq"
              type="text"
              name="qq"
              v-model="form.qq"
              placeholder="请输入QQ号码"
            />
          </div>
          <span class="error-txt" v-if="errors.fields && errors.fields.qq">{{
            errors.fields.qq[0].message
          }}</span>
        </div>
        <div class="form_item">
          <div class="col">
            <label for="teacher">
              指导老师：
            </label>
            <input
              :disabled="!isLogin"
              class="input"
              id="teacher"
              type="text"
              name="teacher"
              v-model="form.teacher"
              placeholder="请输入指导老师"
            />
          </div>
        </div>
        <div class="form_item">
          <div class="col">
            <label for="joinSid">
              参赛学校ID：
            </label>
            <input
              :disabled="!isLogin"
              class="input"
              id="joinSid"
              type="text"
              name="joinSid"
              v-model="form.joinSid"
              placeholder="请输入参赛学校ID"
            />
          </div>
          <p class="contact-teacher">
            请联系指导老师前往以下链接报名获取参赛学校ID：
            <a href="http://www.ncda.org.cn/signup"
              >http://www.ncda.org.cn/signup</a
            >
          </p>
        </div>

        <button class="btn-apply orange" @click="submitApply">
          {{ infoBtnTxt }}
        </button>
      </div>
      <div class="info-box" v-else>
        <template v-if="!isShowSchoolForm && isLogin">
          <div class="school-info-box" v-show="loadingSchoolForm">
            <div class="item">
              <div class="label">手机号：</div>
              {{ schoolInfo.phone }}
            </div>
            <div class="item">
              <div class="label">QQ号：</div>
              {{ schoolInfo.qq }}
            </div>
            <div class="item">
              <div class="label">姓名：</div>
              {{ schoolInfo.name }}
            </div>
            <div class="item">
              <div class="label">省份：</div>
              {{ schoolInfo.pname }}
            </div>
            <div class="item">
              <div class="label">学校：</div>
              {{ schoolInfo.schoolName }}
            </div>
            <div class="item">
              <div class="label">院系：</div>
              {{ schoolInfo.faculty }}
            </div>
            <div class="item">
              <div class="label">指导老师：</div>
              {{ schoolInfo.teacher }}
            </div>
          </div>
          <button
            class="btn-apply orange"
            v-show="loadingSchoolForm"
            @click="toApplyPage"
          >
            去提交作品
          </button>
        </template>
        <template v-else>
          <div class="form_item">
            <div class="col">
              <label for="phone">
                <i>*</i>
                手机号码：
              </label>
              <input
                :disabled="!isLogin"
                class="input"
                id="phone"
                type="text"
                name="phone"
                v-model="schoolform.schoolphone"
                placeholder="请输入手机号码"
              />
            </div>
            <span
              class="error-txt"
              v-if="schoolErrors.fields && schoolErrors.fields.schoolphone"
              >{{ schoolErrors.fields.schoolphone[0].message }}</span
            >
          </div>
          <div class="form_item">
            <div class="col">
              <label for="authcode">
                <!-- <i>*</i>
              手机号码： -->
              </label>
              <input
                :disabled="!isLogin || !schoolform.schoolphone"
                class="input"
                id="input-code"
                type="text"
                name="authcode"
                v-model="schoolform.authcode"
                placeholder="请输入验证码"
              />
              <div
                :class="{ 'is-disabled': isDisabled }"
                class="btn-code"
                @click="getMsgCode"
              >
                {{ codeTxt }}
              </div>
            </div>
            <span
              class="error-txt"
              v-if="schoolErrors.fields && schoolErrors.fields.authcode"
              >{{ schoolErrors.fields.authcode[0].message }}</span
            >
          </div>
          <button class="btn-apply orange" @click="submitCode">
            提交
          </button>
        </template>
      </div>
    </template>
    <p v-else class="small-txt orange-txt">{{ hasApplyTxt }}</p>
    <van-loading v-if="loading" class="img-loading" type="spinner" size="30" />
    <van-popup v-model="isShowSchoolPop" class="school-tip-pop">
      <div class="txt">
        <van-icon name="warning" />
        <div>
          该手机号未在NCDA大赛未来设计师平台上完成作品信息提交，无法选择“院校组织”投稿，请前往
          <a href="http://www.fd.show/member/login/ds"
            >http://www.fd.show/member/login/ds</a
          >
          提交作品信息。
        </div>
      </div>
      <div class="btn-go-ncda">
        <a href="http://www.fd.show/member/login/ds">
          立即前往
        </a>
      </div>
    </van-popup>
  </div>
</template>
<script>
import AsyncValidator from 'async-validator';
import { seasonId } from '../common/argumentId';

export default {
  name: 'UserInfoForm',
  props: {
    isLogin: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: false,
      timer: '',
      state: 0, // 新增提交
      infoBtnTxt: '提交报名',
      showProvincePop: false,
      showCityPop: false,
      showSchoolPop: false,
      showGradePop: false,
      activeIcon: require('../assets/images/btn_checked.jpg'),
      inactiveIcon: require('../assets/images/btn_unchecked.jpg'),
      provinceArr: [], // 省
      cityArr: [], // 市
      // 学校数组
      schoolArr: [],
      provinceValue: {},
      cityValue: {},
      schoolValue: {},
      // gradeValue: {},
      schoolKeyWord: '',
      // 个人表单
      form: {
        name: '', // 姓名
        province: '', //省
        city: '', // 市
        school: '', // 学校
        profession: '', // 院系
        // grade: '', // 年级
        phone: '', // 手机号
        qq: '', // qq号码
        teacher: '', // 老师
        joinSid: '' //同意
      },
      errors: {},
      rules: {
        name: {
          validator: (rule, value, callback) => {
            if (!String(value)) {
              return callback(`请输入真实姓名`);
            } else if (String(value).length > 8) {
              return callback(`请输入8个字内真实姓名`);
            } else {
              callback();
            }
          }
        },
        province: {
          validator: (rule, value, callback) => {
            if (!String(value)) return callback(`请选择学校所在省份`);
            callback();
          }
        },
        city: {
          validator: (rule, value, callback) => {
            if (!String(value)) return callback(`请选择学校所在城市`);
            callback();
          }
        },
        school: {
          validator: (rule, value, callback) => {
            if (!String(value)) return callback(`请输入关键词查询并选择学校`);
            callback();
          }
        },
        profession: {
          validator: (rule, value, callback) => {
            if (!String(value)) return callback(`请输入院系`);
            callback();
          }
        },
        // grade: {
        //   validator: (rule, value, callback) => {
        //     if (!String(value)) return callback(`请选择所在年级`);
        //     callback();
        //   }
        // },
        phone: {
          validator: (rule, value, callback) => {
            let reg = /^[1][3,4,5,7,8][0-9]{9}$/;
            if (!String(value)) {
              return callback(`请输入手机号码`);
            } else if (!reg.test(value)) {
              return callback(`请输入正确的手机号码`);
            } else {
              callback();
            }
          }
        },
        qq: {
          validator: (rule, value, callback) => {
            let reg = /^\d+$/;
            if (!String(value)) {
              return callback(`请输入QQ号码`);
            } else if (!reg.test(value)) {
              return callback(`请输入正确的QQ号码`);
            } else {
              callback();
            }
          }
        }
      },
      // 学校表单----------------------------------------------
      schoolform: {
        schoolphone: '',
        authcode: ''
      },
      schoolErrors: {},
      // schoolBtnTxt: '提交',
      schoolRules: {
        schoolphone: {
          validator: (rule, value, callback) => {
            let reg = /^[1][3,4,5,7,8][0-9]{9}$/;
            if (!String(value)) {
              return callback(`请输入手机号码`);
            } else if (!reg.test(value)) {
              return callback(`请输入正确的手机号码`);
            } else {
              callback();
            }
          }
        },
        authcode: {
          validator: (rule, value, callback) => {
            if (!String(value)) {
              return callback(`请输入验证码`);
            } else if (
              value.length == 6 &&
              (String(value) == '000000' || Number(value))
            ) {
              callback();
            } else {
              return callback(`请输入正确的验证码`);
            }
          }
        }
      },
      codeTxt: '发送验证码',
      isDisabled: false,
      isShowSchoolPop: false,
      schoolInfo: {
        name: '', // 姓名
        pname: '', //省
        schoolName: '', // 学校
        faculty: '', // 院系
        phone: '', // 手机号
        qq: '', // qq号码
        teacher: '' // 老师
      },
      isShowSchoolForm: false, //是否显示手机号验证码表单
      loadingSchoolForm: false,
      hasApplyTxt: '',
      canDoSm: true
    };
  },
  computed: {
    isPerson() {
      return window.location.hash.split('#')[1] === '/works/1' ? true : false;
    }
  },
  mounted() {
    if (this.isLogin) {
      // 查询个人信息---看是否有data
      this.getPersonInfo();
      if (this.$route.path == '/works/1') {
        this.queryProvince();
      }
    }
  },
  watch: {
    isLogin: function() {
      if (this.isLogin) {
        this.getPersonInfo();
        this.queryProvince();
      } else {
        Object.assign(this.$data, this.$options.data());
      }
    }
  },
  methods: {
    // 查个人信息
    async getPersonInfo() {
      this.loadingAll = true;
      try {
        const res = await this.$http.apiIsSign();
        const { data } = res.data;
        if (data) {
          if (this.$route.path == '/works/1') {
            // 有报过名，进入个人
            if (data.ncda == 0) {
              // 是在个人报名的，走原有逻辑，赋值可切换投稿
              this.infoBtnTxt = '修改报名';
              this.state = 1;
              this.form.name = data.name;
              this.form.province = data.pid; // 回显省市通过验证
              this.provinceValue = {
                name: data.pname,
                provinceId: data.pid
              };
              this.form.city = data.cid;
              this.cityValue = {
                name: data.cityName,
                cityId: data.cid
              };
              this.form.school = data.schoolName;
              this.schoolKeyWord = data.schoolName;
              this.schoolValue = {
                name: data.schoolName,
                schoolId: data.sid
              };
              this.form.profession = data.faculty;
              this.form.phone = data.phone;
              this.form.qq = data.qq;
              this.form.teacher = data.teacher;
              this.form.joinSid = data.joinSid;
              this.queryCity(this.form.province);
              this.$emit('isApply', true, 0);
            } else {
              this.canDoSm = false;
              // 不是对应的
              this.hasApplyTxt =
                '您已选择“院校组织”通道报名参赛。若需修改相关信息，请前往“院校组织”通道修改提交。';
              this.$emit('isApply', true, 0, '请前往“院校组织”页面投稿');
              // this.$toast(`您已选择 “院校组织” 通道报名投稿`);
            }
          } else {
            // 有报过名，进入组织
            if (data.ncda == 1) {
              // 请求接口，赋值更新信息
              this.getSignSchoolInfo();
            } else {
              this.canDoSm = false;
              this.hasApplyTxt =
                '您已选择“学生个人”通道报名参赛。若需修改相关信息，请前往“学生个人”通道修改提交。';
              this.$emit('isApply', true, 0, '请前往“学生个人”页面投稿');
              // this.$toast(`您已选择 “学生个人” 通道报名投稿`);
            }
          }
        } else {
          if (this.$route.path == '/works/2') {
            this.isShowSchoolForm = true;
          }
        }
        this.loadingAll = false;
      } catch (error) {
        this.state = 0;
        this.$emit('isApply', false, 0);
        this.loadingAll = false;
      }
    },
    // 已报名查询信息并回显
    async getSignSchoolInfo() {
      try {
        const res = await this.$http.apiSignSchoolInfo({ seasonId });
        const { data } = res.data;
        this.$bus.$emit('works', data.works);
        this.schoolInfo = data;
        this.isShowSchoolForm = false;
        this.$emit('isApply', true, 0);
        this.loadingSchoolForm = true;
      } catch (error) {
        this.loadingSchoolForm = false;
        console.log(error);
      }
    },
    // 已在ncda报名，跳转投稿
    toApplyPage() {
      this.$emit('handleTab', '1');
    },
    // 获取验证码
    async getMsgCode() {
      if (this.isLogin) {
        if (!this.isDisabled) {
          let reg = /^[1][3,4,5,7,8][0-9]{9}$/;
          let phone = this.schoolform.schoolphone;
          if (!String(phone)) {
            this.$Toast('请输入手机号');
          } else {
            if (!reg.test(phone)) {
              this.$Toast('请输入正确的手机号码');
            } else {
              try {
                await this.$http.apiSendCode({
                  phone: Number(this.schoolform.schoolphone)
                });
                this.countDown();
              } catch (error) {
                console.log(error);
              }
            }
          }
        }
      } else {
        this.$Toast('请先登录');
      }
    },
    // 验证码倒计时
    countDown() {
      let time = 60;
      const interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.codeTxt = `${time}S`;
          this.isDisabled = true;
        } else {
          clearInterval(interId);
          this.isDisabled = false;
          this.codeTxt = '发送验证码';
        }
      }, 1000);
    },
    // 组织提交验证码
    async submitCode() {
      if (this.isLogin) {
        this.schoolErrors = await new AsyncValidator(this.schoolRules)
          .validate(this.schoolform)
          .catch(e => e);

        if (this.schoolErrors) {
          return;
        } else {
          // 通过验证
          this.verifyCodeFn();
        }
        this.schoolErrors = {};
      } else {
        this.$Toast('请先登录');
      }
    },
    // 验证验证码
    async verifyCodeFn() {
      try {
        const res = await this.$http.apiVerifyCode({
          seasonId,
          phone: this.schoolform.schoolphone,
          code: this.schoolform.authcode
        });
        const { data } = res.data;
        if (data) {
          if (!data.works) {
            this.isShowSchoolPop = true;
            this.loadingSchoolForm = false;
          } else {
            this.isShowSchoolForm = false;
            this.schoolInfo = data;
            this.loadingSchoolForm = true;
            this.$emit('isApply', true, 0);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 查询省
    async queryProvince() {
      try {
        const res = await this.$http.apiProvince();
        if (res.data.data && res.data.data.length) {
          res.data.data.forEach(item => {
            this.provinceArr.push({
              name: item.name,
              provinceId: item.provinceId
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 查询市
    async queryCity(pid) {
      this.cityArr = [];
      try {
        const res = await this.$http.apiCity({ pid });
        if (res.data.data && res.data.data.length) {
          res.data.data.forEach(item => {
            this.cityArr.push({
              name: item.name,
              cityId: item.cityId
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    //  查学校
    async querySchool(val) {
      if (val) {
        try {
          const res = await this.$http.apiSchool({
            provinceId: this.form.province,
            cityId: this.form.city,
            type: 3,
            name: val
          });
          const { data } = res.data;
          this.schoolArr = res.data.data;
          if (data.length) {
            this.schoolArr = res.data.data;
          } else {
            this.schoolArr = [
              {
                id: 'no',
                name: '暂无数据',
                disabled: true
              }
            ];
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 验证
    async submitApply() {
      if (this.isLogin) {
        this.errors = await new AsyncValidator(this.rules)
          .validate(this.form)
          .catch(e => e);
        if (this.errors) {
          return;
        } else {
          // 通过验证
          this.submitInfo();
        }
        this.errors = {};
      } else {
        this.$Toast('请先登录');
      }
    },
    // 验证通过提交信息
    async submitInfo() {
      let body = {
        name: this.form.name,
        pid: this.provinceValue.provinceId,
        pname: this.provinceValue.name,
        cid: this.cityValue.cityId,
        cityName: this.cityValue.name,
        sid: this.schoolValue.schoolId,
        schoolName: this.schoolValue.name,
        faculty: this.form.profession,
        // grade: this.gradeValue.gradeId,
        teacher: this.form.teacher,
        phone: this.form.phone,
        qq: this.form.qq,
        joinSid: this.form.joinSid,
        dev: 1
      };
      console.log(body);
      try {
        this.loading = true;
        await this.$http.apiSignUp({ ...body });
        if (this.state === 0) {
          this.$Toast('提交成功，请填写作品信息');
          this.state === 1;
          this.$emit('isApply', true, 1);
        } else {
          this.$Toast('修改成功');
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 显示选择面板
    showPopup(val) {
      if (this.isLogin) {
        if (val === 'province') {
          if (this.provinceArr.length) {
            this.showProvincePop = true;
          } else {
            this.$Toast('暂无数据');
          }
        }
        // if (val === 'grade') {
        //   this.showGradePop = true;
        // }
        if (val === 'city') {
          this.form.province
            ? (this.showCityPop = true)
            : this.$Toast('请先选择省份');
        }
        if (val === 'school') {
          if (!this.form.province || !this.form.city) {
            this.$Toast('请先选择省份和城市');
          } else {
            this.showSchoolPop = true;
          }
        }
      } else {
        return false;
      }
    },
    // 关闭面板
    clickAreaFn(e) {
      let targets1 = 'van-picker__confirm'; // 确认
      let targets2 = 'van-picker__cancel'; // 取消
      let targets3 = 'van-overlay van-fade-enter van-fade-enter-active'; // 面板外
      if (
        e.target.className == targets1 ||
        e.target.className == targets2 ||
        e.target.className == targets3
      ) {
        this.showProvincePop = false;
        this.showCityPop = false;
        this.showSchoolPop = false;
        this.showGradePop = false;
        this.schoolKeyWord = '';
      }
    },
    // 确认省选择
    confirmProvincePop(val) {
      this.form.province = val.provinceId;
      this.provinceValue = {
        name: val.name,
        provinceId: val.provinceId
      };
      // 查询对应的市 清空城市学校
      this.form.city = '';
      this.queryCity(this.form.province);
      this.form.school = '';
      this.schoolKeyWord = '';
      this.schoolArr = [];
      this.schoolValue = {
        name: '',
        schoolId: ''
      };
    },
    // 确认市选择
    confirmCityPop(val) {
      this.form.city = val.cityId;
      this.cityValue = {
        name: val.name,
        cityId: val.cityId
      };
      this.form.school = '';
      this.schoolKeyWord = '';
      this.schoolArr = [];
      this.schoolValue = {
        name: '',
        schoolId: ''
      };
    },
    // 搜索学校
    searchSchool() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.querySchool(this.schoolKeyWord);
      }, 300);
    },
    // 确认学校选择
    confirmSchoolPop(val) {
      if (val && val.id !== 'no') {
        this.form.school = val.name;
        this.schoolKeyWord = val.name;
        this.schoolValue = {
          name: val.name,
          schoolId: val.id
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#userInfo {
  position: relative;
  input {
    background: none;
  }
  width: 750px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-size: 32px;
  .info-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form_item {
    width: 600px;
    margin-bottom: 20px;
    position: relative;

    i {
      color: red;
      margin-right: 10px;
    }
    .col {
      display: flex;
      label {
        width: 200px;
        display: flex;
        justify-content: flex-end;
      }

      .radio-group {
        display: flex;
        img {
          width: 41px;
          height: 41px;
        }
        .van-radio {
          margin: 0 15px;
          height: 50px;
          /deep/ .van-radio__icon {
            width: 41px;
            height: 41px;
          }
        }
      }
    }

    .input {
      appearance: none;
      height: 60px;
      width: 400px;
      // border: 1px solid #000;
      border-radius: 4px;
      outline: none;
      background: #eee;
      text-indent: 20px;
      border: 1px solid #000;
      // 选中省市
      .select-div {
        line-height: 60px;
      }
    }
    input:disabled {
      background-color: #eee;
      opacity: 1;
      -webkit-opacity: 1;
    }
    .btn-code {
      position: absolute;
      right: 0;
      height: 60px;
      line-height: 60px;
      background-color: #ff874b;
      border: 1px solid #000;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      color: #fff;
      font-size: 24px;
      padding: 0 10px;
    }
  }

  .error-txt {
    color: red;
    font-size: 24px;
    margin-left: 200px;
  }
  .contact-teacher {
    font-size: 24px;
    margin-left: 200px;
    a {
      color: #ff874b;
    }
  }
}

.userInfo_btn {
  width: 100px;
  height: 30px;
  border: none;
  border-radius: 4px;
  background-color: #e4393c;
  outline: none;
  cursor: pointer;
  color: #fff;
}
// div的placeholder
.input:empty::before {
  line-height: 60px;
  color: #ccc;
  content: attr(placeholder);
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}
.placeholder {
  line-height: 60px;
  color: #ccc;
}

/deep/ .van-picker-column,
/deep/ .van-picker__cancel,
/deep/ .van-picker__title,
/deep/ .van-picker__confirm {
  font-size: 34px;
}
/deep/ .van-picker__toolbar {
  height: 70px;
}
.search-bar {
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  .search-input {
    width: 100%;
    text-indent: 30px;
    border: 1px solid #ff874b;
    color: #ff874b;
  }
  .icon-search {
    width: 40px;
    height: 40px;
  }
}
.img-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -120%);
  color: #ff874b;
}

.btn-apply {
  margin-top: 30px;
  width: 300px;
  height: 70px;
  font-size: 34px;
  font-weight: 600;
  border-radius: 5px;
}

.gray {
  background-color: #bebebe;
  color: rgb(88, 88, 88);
}

.orange {
  background-color: #ff874b;
  color: #fff;
}
.is-disabled {
  -webkit-filter: grayscale(100%) !important;
  -moz-filter: grayscale(100%) !important;
  -ms-filter: grayscale(100%) !important;
  -o-filter: grayscale(100%) !important;
  filter: grayscale(100%) !important;
  filter: gray !important;
}
.school-tip-pop {
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .van-icon-warning {
    color: red;
    margin-right: 10px;
    font-size: 40px;
    margin-top: 10px;
  }
  .txt {
    display: flex;
    a {
      color: #ff874b;
    }
  }
  .btn-go-ncda {
    padding: 0 20px;
    background-color: #ff874b;
    margin-top: 20px;
    border-radius: 4px;
    a {
      color: #fff;
    }
  }
}
.school-info-box {
  .item {
    display: flex;
    div {
      width: 200px;
      text-align: right;
    }
  }
}
.small-txt {
  font-size: 26px;
  padding: 0 40px;
}
.small-txt.orange-txt {
  color: #ff874b;
}
</style>
